import Client from "../client/ApiClient"

const getGroups = () => Client.get("groups/")

const createGroup = (data) => Client.post("groups/", data)

const deleteGroup = (groupId) => Client.delete(`groups/${groupId}/`)

const updateGroupName = (groupId, data) => Client.put(`groups/${groupId}/`, data)

const getVisiblePermission = (idGroup) =>
  Client.get(`group/${idGroup}/permissions/visible/`)

const getCurrentPermission = (idGroup) => Client.get(`group/${idGroup}/permissions/`)

const updatePermission = (data, idGroup) =>
  Client.put(`group/${idGroup}/permissions/`, data)

const getStaffs = (params) => Client.get("staffs/", { params })

const createStaff = (data) => Client.post("staffs/", data)

const updateStaff = (data, staffId) => Client.put(`staff/${staffId}/`, data)

const deleteStaff = (staffId) => Client.delete(`staff/${staffId}/`)

const PermissionRepository = {
  getGroups,
  createGroup,
  deleteGroup,
  updateGroupName,
  getVisiblePermission,
  getCurrentPermission,
  updatePermission,
  getStaffs,
  createStaff,
  updateStaff,
  deleteStaff
}
export default PermissionRepository
